export default {
  color: ["rgba(76, 145, 246, 1)", "rgba(82, 204, 197, 1)"],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {
    show: false,
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  xAxis: {
    type: "value",
    boundaryGap: [0, 0.01],
    splitLine: {
      lineStyle: {
        type: "dashed",
        color: "rgba(255,255,255, .2)",
      },
    },
  },
  yAxis: {
    type: "category",
    data: [],
  },
  series: [
    {
      name: "2012",
      type: "bar",
      data: [],
      barWidth: 8,
      itemStyle: {
        borderRadius: [0, 4, 4, 0],
      },
    },
  ],
  graphic: [{}],
}
